import { render, staticRenderFns } from "./AttachmentDownload.vue?vue&type=template&id=071cf0dc"
import script from "./AttachmentDownload.vue?vue&type=script&lang=js"
export * from "./AttachmentDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports